import { Spin } from 'antd';

import { PREFIX } from '@app/constants/appPrefix';
import '@app/components/AppLoader/styles/AppLoader.desktop.scss';

export const AppLoader = () => {
  return (
    <div data-testid="loader-icon" className={`${PREFIX}app-loader`}>
      <Spin size="large" />
    </div>
  );
};
